import { render, staticRenderFns } from "./EcommerceErrorExpireCard.vue?vue&type=template&id=267920dd&"
import script from "./EcommerceErrorExpireCard.vue?vue&type=script&lang=js&"
export * from "./EcommerceErrorExpireCard.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceErrorExpireCard.vue?vue&type=style&index=0&id=267920dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports